// extracted by mini-css-extract-plugin
export default {"cardContainer":"SearchItemCard_cardContainer__krIbM","name":"SearchItemCard_name__lX5-I","email":"SearchItemCard_email__09FSw","department":"SearchItemCard_department__eiozm"};